// extracted by mini-css-extract-plugin
export default {"tech":"TechSkills_tech__4EInr","techdiv":"TechSkills_techdiv__4E1+z","techimage":"TechSkills_techimage__BRVyP"};